import { useState } from 'react';
// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import ThemeLocalization from './components/ThemeLocalization';
import NotistackProvider from './components/NotistackProvider';
import AndroidAppGate from './components/AndroidAppGate';
// utils
import { captureReferralCodeFromUrl } from './utils/referralCapture';

// ----------------------------------------------------------------------

export default function App() {
  // Runs synchronously during the first render, before Router/OnboardingAwareRedirect's
  // <Navigate> fires — so a `?ref=CODE` landing on `/` is captured into localStorage before the
  // redirect to /onboarding or /auth/login would otherwise drop the query string.
  useState(captureReferralCodeFromUrl);

  return (
    <ThemeConfig>
      <ThemeLocalization>
        <ThemePrimaryColor>
          <RtlLayout>
            <NotistackProvider>
              <ScrollToTop />
              <Router />
              <AndroidAppGate />
            </NotistackProvider>
          </RtlLayout>
        </ThemePrimaryColor>
      </ThemeLocalization>
    </ThemeConfig>
  );
}
